<template>
    <div>
        <template v-if="dashboard === true && data !== null">
          <div class="alert-notification" v-if="$global.user_vr_corp == 'YES'">
            <p> Finja Business has updated its Schedule of Charges from January 5th, 2024 <span class="cursor-pointer" data-toggle="modal" data-target="#absenteesModal">&nbsp;<u>View Details.</u></span></p>
          </div>
            <!-- <div class="row mb-3">
                <div class="col-md-12">
                    <p v-html="balance"></p>
                </div>
            </div> -->
            <div v-if="payroll_processed == 0" class="welcome-screen-main">
                <div class="head align-center mb-5">
                    <h1> Welcome {{user_name}}! </h1>
                    <p> Getting Started with Finja Business is easy, Begin with few steps below and experience a hassle free and fully organized payroll management system. </p>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="welcome-content align-center">
                            <div class="icon-holder">
                                <img src="/images/welcome-icon1.png" alt="" />
                            </div>
                            <div class="text mt-4 mb-3">
                                <p> Finja Business allows manual on-boarding of employees. Create your employee list </p>
                            </div>
                            <router-link to="/employees" class="btn btn-primary"> Add Employee</router-link>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="welcome-content align-center">
                            <div class="icon-holder">
                                <img src="/images/welcome-icon2.png" alt="" />
                            </div>
                            <div class="text mt-4 mb-3">
                                <p> Finja Business allows manual on-boarding of vendors. Create your vendors list </p>
                            </div>
                            <router-link to="/vendors" class="btn btn-primary"> Add Vendor</router-link>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="welcome-content align-center">
                            <div class="icon-holder">
                                <img src="/images/welcome-icon3.png" alt="" />
                            </div>
                            <div class="text mt-4 mb-3">
                                <p> Add Valuable information to set up your company profile </p>
                            </div>
                            <router-link to="/companyProfile" class="btn btn-primary"> Edit Company</router-link>
                        </div>
                    </div>
                </div>
                <div class="partner-list-main align-center mt-5 mb-1" v-if="$global.user_vr_corp == 'NO'">
                    <ul class="partner-list">
                        <li class="d-inline-block partner-list-item"> <img v-bind:src="'/banks/'+$global.user_company_payment_engine+'.png'" alt="" /> </li>
                    </ul>
                </div>
            </div>
            <div v-if="payroll_processed > 0">
                <div class="row">
                    <div class="col-md-9 dashboard-left">
                        <div class="row top-widgets-row">
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box active-employee">
                                    <div class="top-box">
                                        <span class="title" :title="data.activeEmployee"> <em class="rollover"> {{data.activeEmployee}} </em> </span>
                                        <p> Active Employees </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box payroll-processed">
                                    <div class="top-box">
                                        <span class="title" :title="data.payrollProcessed"> <em class="rollover"> {{data.payrollProcessed}} </em> </span>
                                        <p> Payroll(s) Processed </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box last-payroll">
                                    <div class="top-box">
                                        <span class="title" :title="data.payrollProcessedAmount"> <em class="rollover"> {{formatAmount(data.payrollProcessedAmount)}} </em> </span>
                                        <p> Last Payroll Volume </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col charts">
                                <div class="charts-holder">
                                    <div class="chart-head mb-0">
                                        <h2> Payroll </h2>
                                        <div class="filters">
                                            <div class="row">
                                                <div class="col">
                                                    <select class="selectpicker custom-select2" v-model="updateChartOption" @change="updateChart">
                                                    <option value="categories"> By Categories </option>
                                                    <option value="departments"> By Department </option>
                                                    <option value="branches"> By Branch </option>
                                                    <option value="cities"> By City </option>
                                                </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chart-inner payrol-chart">
                                        <div id="employeePayroll" class="chart"></div>
                                    </div>
                                    <div class="chart-head emp-count-chart-head">
                                        <h2> Employee Count </h2>
                                    </div>
                                    <div class="chart-inner">
                                        <div id="employeeCount" class="chart" ></div>
                                    </div>
                                    <div class="chart-head emp-count-chart-head">
                                        <h2> Employee Count Waterfall </h2>
                                    </div>
                                    <div class="chart-inner emp-count-chart">
                                        <div id="employeeWaterFall" class="chart"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 dashboard-right">
                        <div class="dashboard-right-main">
                            <div class="d-right-box recent-added">
                                <h2> Recently Added Employee(s) </h2>
                                <div class="recent-added-inner">
                                    <div v-for="employee in data.recentlyAddedEmployee" v-bind:key="employee.id" class="recent-added-emp-box">
                                        <div class="emp-title">
                                            {{employee.name.charAt(0).toUpperCase()}}
                                        </div>
                                        <p class="emp-detail">
                                            {{employee.name}}
                                            <span class="added-date">
                                                <i class="far fa-clock"></i> {{employee.created_at | date_time_format}}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="d-right-box average-tenure mt-3">
                                <h2> Average Employee Tenure </h2>
                                <select class="custom-select2 selectpicker" @change="updateAverageTenureByDepartment($event.target.value)" >
                                    <option value="0">All Departments</option>
                                    <option v-for="department in data.company_departments" v-bind:key="department.id" v-bind:value="department.id">{{department.name}}</option>
                                </select>
                                <div class="years mt-3">
                                    <strong class="year-numbers"> {{averageTenureByDepartment}} </strong>
                                    <span class="year-text"> Years </span>
                                </div>
                            </div>

                            <div class="d-right-box salary-vs-tenure mt-3">
                                <h2> Salary vs Tenure </h2>
                                <div id="salaryTinure" style="min-width: 100%; height: 335px; margin: 0 auto"></div>
                            </div>

                            <div class="d-right-box general-ratio mt-3">
                                <h2> Gender Ratio <span class="text-highlighted"> ({{data.male_ratio_count}}:{{data.female_ratio_count}}) </span> </h2>
                                <div class="pie-holder">
                                    <div id="gender-ratio" style="height: 200px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="dashboard === null && data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="dashboard === false">
            <notAllowed></notAllowed>
        </template>
        <template>
            <div class="modal fade" id="absenteesModal" tabindex="-1" role="dialog" aria-labelledby="absenteesModalLabel" aria-hidden="true">
                <div style="width: 570px" class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="modal-body abentess-popup pr-0 pt-4 pl-0 pt-3 pb-3">
                            <paymentDetail></paymentDetail>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

    var payroll_chart = '';
    var employee_chart = '';
    export default {
        data() {
            return {
                dashboard : null,
                user_name : null,
                data : null,
                payroll_processed : 0,
                averageTenureByDepartment : '--',
                monthly_employee_count : [],
                monthly_payroll_data : [],
                updateChartOption: 'categories',
                // balance: 'Getting Master Account Balance...',
            };
        },
        mounted() {
            this.can('dashboard').then(result => {
                this.dashboard = result.dashboard;
                this.user_name = result.user_name;
            }).then(result => {
                if(this.dashboard == true){
                    this.getCompanySalaryDashboardData();
                    // this.getCurrentBalanceData();
                }
            });
        },
        methods: {
            getCompanySalaryDashboardData : function () {
                // Calling For Dashboard Data
                axios.get('/api/companySalaryDashboardData')
                .then(res => {
                    if(res.status == 200){
                        this.data = res.data;
                        this.payroll_processed = res.data.payrollProcessed;
                        this.monthly_employee_count = res.data.monthly_employee_count;
                        this.monthly_payroll_data = res.data.monthly_payroll_data.data;
                        this.averageTenureByDepartment = res.data.avg_tenure;
                    }
                })
                .then(res => {
                    $('.selectpicker').selectpicker('refresh');
                    if(this.payroll_processed > 0){
                        // this.updateAverageTenureByDepartment(0);
                        this.salaryVSTenure();
                        this.genderRatio();
                        this.employeePayroll();
                        this.employeeCount();
                        this.employeeWaterFall();
                    }
                })
                .catch(err => {
                    console.log(err);
                    $('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Error to load data');
                });
            },
            getCurrentBalanceData: function() {
                this.$Progress.start();
                axios.get('/api/getCurrentBalanceData')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == '200'){
                            this.balance = 'Master Account Balance: ' + this.formatAmount(res.data.data.balance);
                        }else{
                            this.balance = '';
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                });
            },
            updateAverageTenureByDepartment : function(value){
                axios.get('/api/getAverageTenureByDepartment/'+value)
                .then(res => {
                    this.averageTenureByDepartment = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
            },
            salaryVSTenure: function(){
                Highcharts.chart('salaryTinure', {
                    chart: {
                        type: 'scatter',
                        zoomType: 'xy',
                        style: {
                                fontFamily: 'Raleway',
                                color: '#848484',
                                fontWeight: '500',
                                fontSize: '0.56vw',
                            }
                    },

                    title: {
                        text: '',
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: {
                        title: {
                            enabled: true,
                            text: 'Tenure (years)'
                        },
                        startOnTick: true,
                        endOnTick: true,
                        showLastLabel: true
                    },
                    yAxis: {
                        title: {
                            text: 'Salary (Rs)'
                        }
                    },
                    credits: false,
                    legend: {
                        layout: 'vertical',
                        align: 'left',
                        verticalAlign: 'top',
                        x: 100,
                        y: 70,
                        floating: true,
                        backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
                        borderWidth: 1
                    },
                    plotOptions: {
                        scatter: {
                            marker: {
                                radius: 5,
                                states: {
                                    hover: {
                                        enabled: true,
                                        lineColor: 'rgb(100,100,100)'
                                    }
                                }
                            },
                            states: {
                                hover: {
                                    marker: {
                                        enabled: false
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<b>{series.name}</b><br>',
                        pointFormat: '{point.x}, {point.y}',
                        backgroundColor: '#fff',
                        borderColor: '#e0e6e0',
                        borderRadius: 8,
                        borderWidth: 1,
                        shadow: false,
                        headerFormat: '',
                        style: {
                            opacity: 1
                        }
                    },
                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            y: -55
                        },
                    },
                    series: [{
                        name: 'Female',
                        color: 'rgba(223, 83, 83, .5)',
                        data: this.data.salaryVsTenureMale

                    }, {
                        name: 'Male',
                        color: 'rgba(119, 152, 191, .5)',
                        data: this.data.salaryVsTenureFemale
                    }]
                });
            },
            genderRatio: function(){
                Highcharts.chart('gender-ratio', {
                    chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: null,
                            plotShadow: false,
                            type: 'pie'
                        },
                        title: {
                            text: ''
                        },
                        tooltip: {
                            pointFormat: '<b>{point.percentage:.1f}%</b>',
                            headerFormat: '',
                            backgroundColor: '#fff',
                            borderColor: '#e0e6e0',
                            borderRadius: 8,
                            borderWidth: 1,
                            shadow: false,
                            headerFormat: '',
                            style: {
                                opacity: 1
                            }
                        },
                        navigation: {
                            buttonOptions: {
                                verticalAlign: 'top',
                                y: -60
                            }
                        },
                        plotOptions: {
                            pie: {
                                size: '120%',
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: false
                                },
                                showInLegend: true
                            }
                        },
                        legend: {
                            enabled: true,
                        },
                        credits: false,
                        series: [{
                            name: 'Gender',
                            data: [{
                                name: 'Male',
                                y: this.data.male_ratio_count,
                                color: '#0e1a35'
                            }, {
                                name: 'Female',
                                y: this.data.female_ratio_count,
                                color: '#eb401f'
                            }]
                        }]
                });
            },
            employeeCount: function(){
                var dates = this.monthly_employee_count.employee_count_dates.toString().split(',');
                var series = this.monthly_employee_count.employee_count.toString().split(',').map(Number);
                employee_chart = Highcharts.chart({
                    chart: {
                        renderTo: 'employeeCount',
                        type: 'column',
                        style: {
                            fontFamily: 'Raleway',
                            borderWidth: 0,
                            align: 'right',
                        }
                    },
                    title: {
                        text: null,
                        align: 'left',
                        x: 0,
                        y: 20,
                        style: {
                            fontFamily: 'Raleway',
                            color: '#848484',
                            fontWeight: '600',
                            fontSize: '20px',
                            lineHeight: '30px',
                        }

                    },
                    credits:false,
                    xAxis: {
                        categories: dates,
                    },
                    yAxis: {
                        min: 0,
                        style: {
                            fontFamily: 'Raleway'
                        },
                        title: {
                            text: null
                        }
                    },
                    tooltip: {
                        pointFormatter: function(){
                            return '<b>'+this.y+'</b> '+this.series.name+'<br/>'
                        } ,
                        shared: true,
                        backgroundColor: '#fff',
                        borderColor: '#e0e6e0',
                        borderRadius: 8,
                        borderWidth: 1,
                        shadow: false,
                        headerFormat: '',
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal'
                        }
                    },
                    legend:{
                        verticalAlign: 'top',
                        align:'right',
                        y: 40,
                    },
                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            y: -60
                        },
                    },
                    series: [{
                        showInLegend: false,
                        name: 'Employee',
                        data: series,
                        color: '#b2d68d',
                        borderWidth: 0,
                        style: {
                            fontFamily: 'Raleway'
                        }
                    }]
                });
            },
            employeePayroll: function (){
                var dates = this.monthly_payroll_data.dates_string.split(',');
                var salary = this.monthly_payroll_data.salary_string.toString().split(',').map(Number);
                var additional = this.monthly_payroll_data.additional_earning_string.toString().split(',').map(Number);
                var reimbursement = this.monthly_payroll_data.reimbursements_string.toString().split(',').map(Number);
                var commissions = this.monthly_payroll_data.commissions_string.toString().split(',').map(Number);
                var deduction = this.monthly_payroll_data.deduction_string.toString().split(',').map(Number);
                var net = this.monthly_payroll_data.net_payable_string.toString().split(',').map(Number);
                payroll_chart = Highcharts.chart({
                    chart: {
                        renderTo: 'employeePayroll',
                        type: 'column',
                        events: {
                            //load: requestData
                        },
                        style: {
                            fontFamily: 'Poppins-Medium',
                            borderWidth: 0,
                            align: 'right',
                        }
                    },
                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            y: -45
                        },
                    },
                    legend:{
                        itemStyle: {
                            fontSize:'12px',
                            fontWeight: '500',
                            color: '#686868'
                        },
                        itemWidth: 150,
                        verticalAlign: 'top',
                        align:'right',
                        y: 0,
                    },
                    credits: false,
                    title: {
                        text: null
                    },
                    xAxis: {
                        categories: dates,
                        style: {
                            fontFamily: 'Poppins-Medium'
                        }
                    },
                    yAxis: {
                        allowDecimals: false,
                        title: {
                            text: 'Amount'
                        },
                    },
                    tooltip: {
                        pointFormatter: function(){
                            var price = this.y;
                            // price = price.format(price);
                            return '<span style="color:#282828;"> <b>'+price+'</span></b> '+this.series.name+'<br/>'
                        } ,
                        shared: true,
                        useHTML: true,
                        shadow: false,
                        headerFormat: '',
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal'
                        }
                    },
                    series: [{
                        name: 'Salary',
                        data: salary,
                        color: '#e9488a',
                        borderColor: 'black',
                        borderWidth: 0,
                        style: {
                            fontFamily: 'Poppins-Medium'
                        }
                    }, {
                        name: 'Earnings',
                        data: additional,
                        color: '#fbb06a',
                        borderWidth: 0,
                    }, {
                        name: 'Reimbursements',
                        data: reimbursement,
                        color: '#b2d68d',
                        borderWidth: 0,
                    }, {
                        name: 'Commissions',
                        data: commissions,
                        color: '#68468d',
                        borderWidth: 0,
                    }, {
                        name: 'Deductions',
                        data: deduction,
                        color: '#fd9f28',
                        borderWidth: 0,
                    }, {
                        showInLegend: true,
                        name: 'Others',
                        data: net,
                        color: '#444fe4',
                        borderWidth: 0,
                    }],
                });
            },
            employeeWaterFall: function (){
                Highcharts.chart('employeeWaterFall', {
                    chart: {
                        type: 'waterfall',
                        style: {
                            fontFamily: 'Poppins-Medium',
                            color: '#848484',
                            fontWeight: '500',
                            fontSize: '8px',
                        }
                    },
                    title: {
                        text: null,
                        align: 'left',
                        x: 0,
                        y: 12,
                        style: {
                            fontFamily: 'Poppins-Medium',
                            color: '#848484',
                            fontWeight: '600',
                            fontSize: '20px',
                        }
                    },
                    xAxis: {
                        type: 'category'
                    },
                    credits: false,
                    yAxis: {
                        title: {
                            text: 'Employees',
                            style: {
                                fontFamily: 'Poppins-Medium',
                                color: '#848484',
                                fontWeight: '500',
                                fontSize: '12px',
                            },
                            min: 0
                        }
                    },

                    legend: {
                        enabled: false
                    },
                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            y: -60
                        },
                    },
                    tooltip: {
                        pointFormat: '<b>{point.y} Employees</b>',
                        backgroundColor: '#fff',
                        borderColor: '#e0e6e0',
                        borderRadius: 8,
                        borderWidth: 1,
                        shadow: false,
                        headerFormat: '',
                        style: {
                            opacity: 1
                        }
                    },

                    series: [{
                        data: [{
                            name: this.data.month_key_1,
                            y: this.data.month_value_1,
                            color: '#d8dfe4',
                            borderWidth: 0,
                        }, {
                            name: this.data.month_key_2,
                            y: this.data.month_value_2,
                            color: '#d8dfe4'
                        }, {
                            name: this.data.month_key_3,
                            y: this.data.month_value_3,
                            color: '#fb437b'
                        }, {
                            name: this.data.month_key_4,
                            y: this.data.month_value_4,
                            color: '#d8dfe4'
                        }, {
                            name: this.data.month_key_5,
                            y: this.data.month_value_5,
                        }, {
                            name: this.data.month_key_6,
                            y: this.data.month_value_6,
                            isSum: true,
                            color: '#b2d68d'
                        }],
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                //return Highcharts.numberFormat(this.y / 1000, 0, ',') + 'k';
                            },
                            style: {
                                fontFamily: 'Poppins-Medium',
                                color: '#848484',
                                fontWeight: '500',
                                fontSize: '0.83vw',
                            }
                        },
                        pointPadding: 0
                    }]
                });
            },
            updateChart: function(){
                // console.log(this.updateChartOption);
                var opt = this.updateChartOption;
                switch(opt){
                    case 'categories':
                        this.filterByCategories();
                        break;
                    case 'departments':
                        this.filterByDepartment();
                    break;
                    case 'branches':
                        this.filterByBranches();
                    break;
                    case 'cities':
                        this.filterByCities();
                    break;
                }
            },
            filterByCategories: function(){
                this.$Progress.start();
                axios.get('/api/getMonthlyPayrollData')
                .then(res => {
                    if(res.status == 200){
                        this.employeePayroll();
                        this.employeeCount();
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },
            filterByDepartment: function(){
                this.$Progress.start();
                axios.get('/api/getDepartmentPayrollData')
                .then(res => {
                    if(res.status == 200){
                        var Data = res.data.data;
                        while(employee_chart.series.length > 0){
                            employee_chart.series[0].remove(true);
                        }
                        employee_chart.yAxis[0].setTitle({ text: "Count" });
                        employee_chart.xAxis[0].setTitle({ text: "By Month" });
                        employee_chart.xAxis[0].setCategories(Data.department_payroll_chart.dates);
                        Data.department_chart.departments.forEach(function(department){
                            employee_chart.addSeries({
                                name: department.name,
                                type: 'column',
                                data:department.data
                            });
                        });
                        var seriesLength = payroll_chart.series.length;
                        for(var i = seriesLength - 1; i > -1; i--){
                            payroll_chart.series[i].remove();
                        }
                        payroll_chart.yAxis[0].setTitle({ text: "Count" });
                        payroll_chart.xAxis[0].setTitle({ text: "By Month" });
                        payroll_chart.xAxis[0].setCategories(Data.department_payroll_chart.dates);
                        Data.department_payroll_chart.departments.forEach(function(department){
                            payroll_chart.addSeries({
                                name: department.name,
                                type: 'column',
                                data:department.data
                            });
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },
            filterByBranches: function(){
                this.$Progress.start();
                axios.get('/api/getBranchPayrollData')
                .then(res => {
                    if(res.status == 200){
                        var Data = res.data.data;
                        while(employee_chart.series.length > 0){
                            employee_chart.series[0].remove(true);
                        }
                        employee_chart.yAxis[0].setTitle({ text: "Count" });
                        employee_chart.xAxis[0].setTitle({ text: "By Month" });
                        Data.branch_chart.branches.forEach(function(branch){
                            employee_chart.addSeries({
                                name: branch.name,
                                type: 'column',
                                data:branch.data
                            });
                        });
                        var seriesLength = payroll_chart.series.length;
                        for(var i = seriesLength - 1; i > -1; i--){
                            payroll_chart.series[i].remove();
                        }
                        payroll_chart.yAxis[0].setTitle({ text: "Count" });
                        payroll_chart.xAxis[0].setTitle({ text: "By Month" });
                        payroll_chart.xAxis[0].setCategories(Data.branch_payroll_chart.dates);
                        Data.branch_payroll_chart.branches.forEach(function(branch){
                            payroll_chart.addSeries({
                                name: branch.name,
                                type: 'column',
                                data:branch.data
                            });
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },
            filterByCities: function(){
                this.$Progress.start();
                axios.get('/api/getCitiesPayrollData')
                .then(res => {
                    if(res.status == 200){
                        var Data = res.data.data;
                        while(employee_chart.series.length > 0){
                            employee_chart.series[0].remove(true);
                        }
                        employee_chart.yAxis[0].setTitle({ text: "Count" });
                        employee_chart.xAxis[0].setTitle({ text: "By Month" });
                        Data.city_chart.cities.forEach(function(city){
                            employee_chart.addSeries({
                                name: city.name,
                                type: 'column',
                                data:city.data
                            });
                        });
                        var seriesLength = payroll_chart.series.length;
                        for(var i = seriesLength - 1; i > -1; i--){
                            payroll_chart.series[i].remove();
                        }
                        payroll_chart.xAxis[0].setCategories(Data.city_payroll_chart.dates);
                        payroll_chart.yAxis[0].setTitle({ text: "Count" });
                        payroll_chart.xAxis[0].setTitle({ text: "By Month" });
                        Data.city_payroll_chart.cities.forEach(function(city){
                            payroll_chart.addSeries({
                                name: city.name,
                                type: 'column',
                                data:city.data
                            });
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },
        }
    }
</script>
